import router from './router/router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// import { Message } from 'element-ui'
import { Route } from 'vue-router'
import { getCookie, removeCookie } from '@/utils/cookies'

NProgress.configure({ showSpinner: false })

// not need token page
const whiteList = ['/login', '/find-password']

router.beforeEach((to: Route, from: Route, next: any) => {
  const token = getCookie('token')
  NProgress.start()
  // next()
  /* 后端接口报错时可以注释这一段 */
  if (token) {
    // with token to login
    if (to.path === '/login') {
      next('/')
      NProgress.done()
    } else {
      // TODO: 详细的权限验证
      next()
    }
  } else {
    // no token page
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach((to: Route) => {
  NProgress.done()
})
